import { render } from "./home_three_columns.vue?vue&type=template&id=fdfca5a4&scoped=true"
import script from "./home_three_columns.vue?vue&type=script&lang=js"
export * from "./home_three_columns.vue?vue&type=script&lang=js"

import "./home_three_columns.vue?vue&type=style&index=0&id=fdfca5a4&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfca5a4"]])

export default __exports__